import type { KioskBusinessSettings } from '@/lib/request/types/kioskConfig';

export default function defaultTranslationKeys(
  kioskBusinessSettings: KioskBusinessSettings | undefined
) {
  return {
    defaultEmployeeLabel: kioskBusinessSettings?.EMPLOYEE_LABEL || 'employee',
    defaultEmployeeLabelPlural:
      kioskBusinessSettings?.EMPLOYEE_LABEL_PLURAL || 'employees',
    defaultShiftLabel: kioskBusinessSettings?.SHIFT_LABEL || 'shift',
    defaultShiftLabelPlural:
      kioskBusinessSettings?.SHIFT_LABEL_PLURAL || 'shifts',
  };
}
